import { render, staticRenderFns } from "./Self.vue?vue&type=template&id=893c04c8&scoped=true&"
import script from "./Self.vue?vue&type=script&lang=js&"
export * from "./Self.vue?vue&type=script&lang=js&"
import style0 from "./Self.vue?vue&type=style&index=0&id=893c04c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893c04c8",
  null
  
)

export default component.exports